// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2kfEy","large":"styles_large__VVnsv"};